
import * as handlebars_family from "../handlebars_family.js";
import "../layout/familycenter2.mustache";
import "../widget/dropdown.js";
const TPL = handlebars_family.addTemplate("layout/header_logged_family2",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"user") || (depth0 != null ? lookupProperty(depth0,"user") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"user","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":138},"end":{"line":1,"column":278}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"user")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img title=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" class=\"fw-avatar fw-avatar-sizeS\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\" data-fw-onclick=\"modaluser|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"accountId") : depth0), depth0))
    + "\"> ";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"goback|/home.php\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_home",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":329},"end":{"line":1,"column":350}}}))
    + "</icon> ";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"flexauto\" style=\"text-align:center\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pageKey") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":446},"end":{"line":1,"column":464}}})) != null ? stack1 : "")
    + "</span> ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"family") || (depth0 != null ? lookupProperty(depth0,"family") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"family","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":481},"end":{"line":1,"column":854}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"family")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <span class=\"flexauto\" data-widget=\"widget/dropdown\" data-fw-dropdown-root=\".fw-mainmenu\" data-fw-dropdown-commented=\"nav\" style=\"font-weight:500;text-align:center\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " <span class=\"fw-arrow-down\"></span> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"totalNotifCount") || (depth0 != null ? lookupProperty(depth0,"totalNotifCount") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"totalNotifCount","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":706},"end":{"line":1,"column":834}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"totalNotifCount")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </span> ";
},"10":function(container,depth0,helpers,partials,data) {
    return "<span class=\"fw-notification\" style=\"position:relative;top:-10px;left:-5px\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</span>";
},"12":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"panerighttoogle\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"calendar.ic_plan_recipe",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":928},"end":{"line":1,"column":965}}}))
    + "</icon> ";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"goto|settings.php\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_settings",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":1040},"end":{"line":1,"column":1065}}}))
    + "</icon> ";
},"16":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\""
    + container.escapeExpression(lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"addButton") : depth0),{"name":"premiumPermission","hash":{},"data":data,"loc":{"start":{"line":1,"column":1137},"end":{"line":1,"column":1168}}}))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_plus",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":1170},"end":{"line":1,"column":1195}}}))
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <header class=\"fw-mainmenu\"><flexrow class=\"fw-mainmenu-opener\" style=\"gap:var(--space);padding:0 var(--space)\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isPageLaunchpad") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":114},"end":{"line":1,"column":365}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if-and").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"pageKey") : depth0),(depth0 != null ? lookupProperty(depth0,"monofamily") : depth0),{"name":"if-and","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":1,"column":366},"end":{"line":1,"column":866}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"calendarmenu") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":867},"end":{"line":1,"column":980}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"settings") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":981},"end":{"line":1,"column":1080}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"addButton") : depth0),{"name":"premiumPermission","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1081},"end":{"line":1,"column":1225}}})) != null ? stack1 : "")
    + " </flexrow><nav style=\"margin:0 var(--space)\"><!-- "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"layout/familycenter2"),depth0,{"name":"layout/familycenter2","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " --></nav></header> ";
},"usePartial":true,"useData":true});
export default TPL;